export const AUTH_TOKEN = "auth_token";
export const USER_INFO = "user_info";
export const LANG_ID = "lang_id";
